import React, {Component} from 'react';
import {fromJS} from 'immutable';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import PageTitle from '../../../components/commons/pages/PageTitle';
import ProductList from '../../../components/cart/ProductList';
import ProductListMobile from '../../../components/cart/ProductListMobile';
import BillDetails from '../../../components/cart/BillDetails';
import BillDetailsMobile from '../../../components/cart/BillDetailsMobile';
import View from '../../../utils/viewHelpers';
import * as User from '../../../utils/userHelpers';
import * as Cart from '../../../utils/cartHelper';
import * as Orders from '../../../utils/ordersHelper';
import * as CartActions from '../../../actions/cartActions';
import * as OrdersActions from '../../../actions/ordersActions';
import Loader from '../../../components/commons/loader/loader';
import SweetAlert from 'sweetalert-react';
import * as Utils from '../../../utils/utils';
import withSizes from 'react-sizes';

class CartPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cartItems: {},
      billDetails: {},
      showAlert: false,
      swalParams: {
        title: ""
      },
      discountMessage: '',
      isUserLoggedIn: false
    }

    this.loadCart = this.loadCart.bind(this);
    this.addressUpdated = this.addressUpdated.bind(this);
    this.IsAddressOutside = this.IsAddressOutside.bind(this);
    this.setPriceUpdate = this.setPriceUpdate.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.onChangeProductQuantity = this.onChangeProductQuantity.bind(this);
    this.onChangeTipPercent = this.onChangeTipPercent.bind(this);
    this.deleteProduct = this.deleteProduct.bind(this);
    this.checkOrderDetails = this.checkOrderDetails.bind(this);
    this.onApplyCoupon = this.onApplyCoupon.bind(this);
    this.onRemoveCoupon = this.onRemoveCoupon.bind(this);
    this.onChangeCustomTipValue = this.onChangeCustomTipValue.bind(this);
    this.transformCartItemPriceBasedBasedOnAddress = this.transformCartItemPriceBasedBasedOnAddress.bind(this);
  }

  componentDidMount() {

    const { location, match } = this.props;

    if (!User.isLoggedIn()) {
      //Load cart for no logged in user
      this.setState({ isUserLoggedIn: true });
      this.loadCart();
      return;
    } else {
      this.setState({ isUserLoggedIn: true });
      this.loadCart();
    }
    window.scrollTo(0, 0);
    window.addEventListener('address_changed', this.addressUpdated);
  }

  componentWillUnmount() {
    window.removeEventListener('address_changed', this.addressUpdated);
    window.scrollTo(0, 0);
  }

  addressUpdated(e) {
    let cart = e.detail;
    let IsAddressOutside = this.IsAddressOutside();
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];
    if (cartItemList.length > 0) {
      let newPriced = this.transformCartItemPriceBasedBasedOnAddress(cartItemList, IsAddressOutside);
      this.setPriceUpdate(cart[Cart.ATTRIBUTE_CART_ITEMS], newPriced);
    }
    this.loadCart();
  }

  IsAddressOutside() {
    let storedAddressValidation = Cart.getCartAttribute(Cart.ATTRIBUTE_DELIVERY_VALIDATION_STATUS);
    let IsAddressOutside = storedAddressValidation && storedAddressValidation.region == 'SHIPPO';
    return IsAddressOutside
  }

  transformCartItemPriceBasedBasedOnAddress(cartItems, isOutside) {
    let copyOfItems = fromJS(cartItems).toJS();
     if (isOutside) {
      copyOfItems.forEach(obj => {
        obj.PriceB = obj.Suggested;
      });
      return copyOfItems;
    } else {
      copyOfItems.forEach(obj => {
        obj.PriceB = Number(obj.Price);
      });
      return copyOfItems;
    }

  }
  setPriceUpdate(cartObj, updatedCartItemArr) {
    Object.keys(cartObj).forEach((key, index) => {
      cartObj[key] = updatedCartItemArr[index]
    });
    CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEMS, {
      items: cartObj
    })
  }

  render() {

    const {cartItems, billDetails, swalParams, showAlert, isUserLoggedIn} = this.state;
    console.log(billDetails);
    const {isMobile, productsLoading, ordersLoading, cart} = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    //console.log('CART_PAGE_STATE', this.state);
    console.log('CART_PAGE_PROPS', this.props);

    return (
      <div className={`page cart-page ${isMobile ? 'mobile' : ''}`}>
        <div className="container">
          <PageTitle title="SHOPPING CART" isMobile />
          {isUserLoggedIn ? (cartItemList.length > 0)
            ? (
              <div>
                {!isMobile ? (
                  <div className="product-list-container">
                    <ProductList viewMode="edit" products={cartItemList} onChangeProductQuantity={this.onChangeProductQuantity} onDeleteProduct={this.deleteProduct}/>
                    <BillDetails viewMode="edit" billDetails={billDetails} onChangeTipPercent={this.onChangeTipPercent} onChangeCustomTipValue={this.onChangeCustomTipValue} onApplyCoupon={this.onApplyCoupon} onRemoveCoupon = {this.onRemoveCoupon} discountMessage={this.state.discountMessage}/>
                  </div>
                ) : (
                  <div className="product-list-container">
                    <ProductListMobile viewMode="edit" products={cartItemList} onChangeProductQuantity={this.onChangeProductQuantity} onDeleteProduct={this.deleteProduct}/>
                    <BillDetailsMobile viewMode="edit" billDetails={billDetails} onChangeTipPercent={this.onChangeTipPercent} onChangeCustomTipValue={this.onChangeCustomTipValue} onApplyCoupon={this.onApplyCoupon} onRemoveCoupon = {this.onRemoveCoupon} discountMessage={this.state.discountMessage}/>
                  </div>
                )}

                <div className="footer-section">
                  {!isMobile ? (
                    <div>
                      <div className="checkout-button-container">
                        <Link to="/review-order" href="#">Proceed to checkout</Link>
                      </div>
                      <div className="continue-link-container">
                        or&nbsp;&nbsp;<Link to="/">Continue shopping</Link>
                      </div>
                    </div>
                  ) : (
                    <Link to="/review-order" className="button button-block button-blue" href="#">Proceed to checkout</Link>
                  )}
                </div>

              </div>
            )
            : this.renderEmptyCart() : this.renderNoLoginMessage()}
        </div>
        <Loader visibility={productsLoading || ordersLoading}/>
        <SweetAlert customClass={"with-close"} showCancelButton cancelButtonText={"x"} onCancel={()=> this.setState({showAlert:false})} show={showAlert} {...swalParams} onConfirm={() => this.setState({showAlert: false})}/>
      </div>
    );
  }

  renderEmptyCart() {

    return (
      <div className="empty-cart-container">
        <div className="title">Your shopping cart is empty</div>
        <div className="links">
          <Link to="/">Continue Shopping</Link>
        </div>
      </div>
    )
  }

  renderNoLoginMessage() {
    return (
      <div className="message-container">
        <div className="title">You are not logged in</div>
        <div className="links">
          <Link to="/signin">Please login to continue</Link>
        </div>
      </div>
    )
  }

  loadCart() {

    this.props.dispatch(CartActions.loadCart());
    setTimeout(() => {
      this.checkOrderDetails();
    }, 400);
  }

  checkOrderDetails() {

    const {cart} = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    let tempOrder = Orders.buildTempOrderData(cartItemList);
    console.log("TEMP_ORDER_PAYLOAD", tempOrder);
    this.props.dispatch(OrdersActions.createTempOrder(tempOrder, response => {
      console.log("ORDER_CHECK_RESPONSE", response);
      if (response.status) {
        let billData = Orders.calculateBill(response.data);
        this.setState({billDetails: billData});
      } else {
        // hack to remove promo code in case of errors
        this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_PROMO_CODE));
        this.setState({ showAlert: true, swalParams: {
          title: (response && response.data && response.data.error) ?
                    response.data.error.message : "Something went wrong!",
          type: "error",
          showConfirmButton: false
        }})
        // setTimeout(() => this.setState({showAlert: false}), 2000);
      }
    }))
  }

  onChangeTipPercent(percent) {

    console.log("TIP_PERCENTAGE", percent);
    const {billDetails} = this.state;
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT, {tipPercent: percent}));
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CUSTOM_TIP_AMOUNT, {amount: 0}));
    setTimeout(() => {
      this.checkOrderDetails();
    }, 400);
  }

  onChangeCustomTipValue(value) {
    console.log("ATTRIBUTE_CUSTOM_TIP_AMOUNT", value);
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_TIP_PERCENT, {tipPercent: 0}));
    this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CUSTOM_TIP_AMOUNT, {amount: value}));
    setTimeout(() => {
      this.checkOrderDetails();
    }, 400);
  }

  onApplyCoupon (coupon, callback) {
    const {cart} = this.props;
    const cartItemList = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS])
      : [];

    let tempOrder = Orders.buildTempOrderData(cartItemList);
    this.props.dispatch(CartActions.applyDiscount(coupon, (res) => {
      if(res.status) {
        if (res.data) {
          if(!!callback) {
            callback(res.data)
          }
          if(res.data.data) {
            this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_PROMO_CODE, {promoCode: res.data.data}));
            setTimeout(() => {
              this.checkOrderDetails();
              this.setState({discountMessage:res.data.message});
            }, 400);
          } else {
            this.setState({discountMessage:res.data.message});
          }
        }
      }
    }));
  }

  onRemoveCoupon(coupon, discount) {
          this.setState({discountMessage:''});
          this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_PROMO_CODE, {promoCode: discount }));
          setTimeout(() => {
            this.checkOrderDetails();
      }, 400);
  }

  onChangeProductQuantity(product, newQuantity) {

    console.log("Product quantity changed................", newQuantity);

    const {cart} = this.props;
    const cartItems = cart && cart[Cart.ATTRIBUTE_CART_ITEMS]
      ? cart[Cart.ATTRIBUTE_CART_ITEMS]
      : [];

    if (product.quantity == 1 & newQuantity == 1) {
      this.deleteProduct(product._id);
    } else {
      let isRecommendedProduct = Utils.isRecommendedProduct(product)
      if (!isRecommendedProduct && (product['Qty'] < newQuantity)) {
        this.setState({showAlert: true, swalParams: {
          title: "We are in the process of restocking this item!",
          type: "warning",
          showConfirmButton: false
        }})
        // setTimeout(() => this.setState({showAlert: false}), 2000);
        return;
      }

      let copyOfItems = fromJS(cartItems).toJS();
      copyOfItems[product._id].quantity = newQuantity;
      this.setState({cartItems: copyOfItems})

      this.props.dispatch(CartActions.modifyCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {
        id: product._id,
        details: copyOfItems[product._id]
      }));
      setTimeout(() => {
        this.checkOrderDetails();
      }, 400);
    }

  }

  deleteProduct(productId, callback) {

    const {cart} = this.props;

    if (confirm('Are you want to remove this product?')) {
      this.props.dispatch(CartActions.removeCartAttribute(Cart.ATTRIBUTE_CART_ITEM, {itemId: productId}));
      setTimeout(() => {
        let items = Object.values(cart[Cart.ATTRIBUTE_CART_ITEMS]);
        if (items && items.length > 0)
          this.checkOrderDetails();
      } , 400);
    }

  }

  updateCart(e) {

    let page = this.props.history.location.pathname.replace("\/", "");
    if (page == "cart")
      this.doOnCartChanged(e.detail)
  }
}

const mapSizesToProps = ({ width }) => ({
    isMobile: width < 992
});

export default withSizes(mapSizesToProps)(connect((state) => {
  return {
    cart: state.getIn(['cart', 'cart']),
    user: state.getIn(['users', 'user']),
    ordersLoading: state.getIn(['orders', 'loading']),
    productsLoading: state.getIn(['products', 'loading']),
    error: state.getIn(['products', 'error'])
  };
})(CartPage));



// WEBPACK FOOTER //
// ./src/containers/billing/cart/CartPage.js